import React from 'react'
import { useTranslation } from 'react-i18next'
import PinInput from 'react-pin-input'
import { inputStyles, inputFocusStyle } from './styles'
import { Button } from '@components/Button/Button'
import useCommonStyles from '@screens/OnlineCancellation/commonStyles'
import useStyles from './styles'
import Page from '@components/Page'
import Header from '@components/Header'
import Footer from '@components/Footer'
import { useHandleEnterCallback } from '@hooks/useHandleEnterCallback'
import { useIsPhoneOnly } from 'src/config/mediaQueries'
import { Alert, useTheme } from '@mui/material'

type VerificationStepProps = {
  onConfirm: () => void
  onNameEntered: ((value: string, index: number) => void) | undefined
  onBackClick: () => void
  buttonIsDisabled: boolean
  error?: string
}

export const VerificationStep = ({
  onConfirm,
  onNameEntered,
  onBackClick,
  buttonIsDisabled,
  error,
}: VerificationStepProps) => {
  const { t } = useTranslation()
  const commonClasses = useCommonStyles()
  const classes = useStyles()
  useHandleEnterCallback(onConfirm, buttonIsDisabled)
  const isPhone = useIsPhoneOnly()
  const theme = useTheme()

  const ctaButton = (
    <Button className={commonClasses.buttonWrapper} text={t('confirm_cancellation')} onClick={onConfirm} />
  )

  return (
    <Page
      header={
        <Header
          onBackClick={onBackClick}
          desktopHeadingText={t('verify_name_headline')}
          mobileHeadingText={t('verify_name_headline')}
        />
      }
      body={
        <div className={commonClasses.innerWrapper}>
          <div className={commonClasses.contentWrapper}>
            <div className={classes.descriptionStyles}>{t('enter_first_three_letters')}</div>
            {error && (
              <Alert className={classes.error} severity="error">
                {error}
              </Alert>
            )}
            <PinInput
              length={3}
              type="custom"
              focus
              inputStyle={inputStyles(theme)}
              inputFocusStyle={inputFocusStyle(theme)}
              onChange={onNameEntered}
              autoSelect={true}
              regexCriteria={/^[a-zA-ZäöüßÄÖÜ]+$/}
            />
            {buttonIsDisabled ? null : !isPhone && ctaButton}
          </div>
        </div>
      }
      footer={buttonIsDisabled || !isPhone ? undefined : <Footer button={ctaButton} />}
    />
  )
}
